<template>
    <div class="user-info__settings-menu">
        <div v-if="!isAdmin()" class="user-info__settings-section">
            <div class="user-info__settings-element" @click="emit('main')">
                <div class="user-info__settings-element-back">
                    <img v-svg-inline src="@/assets/icons/ui/back-arrow.svg" />
                </div>

                <span>Дилеры</span>
            </div>
        </div>

        <div v-if="dealers.length > 0" class="user-info__settings-section-group">
            <div
                v-for="dealer in dealers"
                class="user-info__settings-section"
            >
                <div class="user-info__settings-element" @click="handleChangeCurrentDealer(dealer)">
                    <span>{{ dealer.name }}</span>

                    <div
                        v-if="getCurrentUser().dealer_id === dealer.id"
                        class="user-info__settings-element-after user-info__settings-dealer-check"
                    >
                        <img v-svg-inline src="@/assets/icons/ui/check.svg" />
                    </div>
                </div>
            </div>
        </div>

        <router-link
            v-if="!isAdmin()"
            :to="{ name: 'Profile', params: { tab: 'dealers' } }"
            class="user-info__settings-element"
        >
            <img v-svg-inline src="@/assets/icons/settings.svg" />
            <span>Настройка профилей ДЦ</span>
        </router-link>
    </div>
</template>

<script setup lang="ts">
    import { h, onMounted, ref } from 'vue';

    import { injectStrict } from '@/injection/injectStrict.ts';
    import { ModalKey } from '@/injection/keys.ts';

    import { DealerListItem } from '@/types/dealer.type.ts';

    import usePermission from '@/repositories/auth/usePermission.ts';
    import useUserRepository from '@/repositories/user/useUserRepository.ts';

    import ConfirmActionModal from '@/components/modals/ConfirmActionModal/ConfirmActionModal.vue';

    import UserConfirmChangeCurrentDealer from '@/components/profile/UserConfirmChangeCurrentDealer/UserConfirmChangeCurrentDealer.vue';

    const emit = defineEmits<{
        (e: 'main'): void,
    }>();

    const $modal = injectStrict(ModalKey);

    const { isAdmin } = usePermission();
    const { getCurrentUserDealers, getCurrentUser, changeUserCurrentDealer } = useUserRepository();

    const dealers = ref<DealerListItem[]>([]);

    function handleChangeCurrentDealer(dealer: DealerListItem): void {
        emit('main');

        $modal.open({
            component: ConfirmActionModal,
            modalType: 'narrow',
            slots: {
                default: () =>
                    h(UserConfirmChangeCurrentDealer, { dealer }),
            },
            props: {
                onConfirm: async () => {
                    await changeUserCurrentDealer(dealer.id);
                    fetchDealers();
                },
            },
        });
    }

    function fetchDealers(): void {
        if (!isAdmin()) {
            getCurrentUserDealers().then((fetchedDealers: DealerListItem[]) => {
                dealers.value = fetchedDealers;
            });
        }
    }

    onMounted(() => {
        fetchDealers();
    });
</script>
